<template>
  <div class="active-static-tab-content-wrap">
    <div class="active-static-tab-content-ranking">
      <p class="active-static-tab-content-ranking-title">排行榜</p>
      <div class="active-static-tab-content-ranking-split-line"></div>
      <ul class="active-static-tab-content-ranking-ul" v-if="rankingLocalList.length > 0">
        <li class="active-static-tab-content-ranking-item click-element" v-for="(item, index) in rankingLocalList"
          :title="item.name" :key="item.id" @click="changeSelectRank(index)">
          <span class="active-static-tab-content-ranking-item-num" :class="item.id === curStaticLocalData.id
              ? 'active-static-tab-content-ranking-item-name-avtive'
              : ''
            ">{{ index + 1 }}</span>
          <span class="active-static-tab-content-ranking-item-name" :class="item.id === curStaticLocalData.id
              ? 'active-static-tab-content-ranking-item-name-avtive'
              : ''
            ">{{ item.name }}</span>
        </li>
      </ul>
      <ul class="active-static-tab-content-ranking-ul" v-else>
        <li class="active-static-tab-content-ranking-item click-element">
          <span class="active-static-tab-content-ranking-item-name">暂无数据</span>
        </li>
      </ul>
    </div>
    <div class="active-static-tab-content-total">
      <div class="active-static-tab-content-total-sel-box" v-if="activeType == 'class' || 'evaluation'">
        <Select ref="subjectSelectRef" v-model="subjectId" placeholder="全部学科" @on-change="changeSubject($event)"
          v-if="activeType == 'teacher'">
          <Option value="0">全部学科</Option>
          <Option v-for="item in subjectList" :value="item.id" :key="item.id">{{
            item.subject_name
          }}</Option>
        </Select>
        <Select ref="gradeSelectRef" v-model="gradeId" placeholder="全部年级" @on-change="changeGrade($event)">
          <Option value="0">全部年级</Option>
          <Option v-for="item in gradeList" :value="item.id" :key="item.id">{{
            item.grade_name
          }}</Option>
        </Select>
      </div>
      <div class="active-static-tab-content-total-num" :class="activeType == 'teacher'
          ? 'active-static-tab-content-total-num-diff-top'
          : ''
        ">
        <div class="inter-count">
          <img src="../../../assets/images/databoard/inter-cirle-one-small.png" width="100%" height="100%"
            class="big-img" />
          <div class="cirle-small">
            <img src="../../../assets/images/databoard/inter-cirle-two-small.png" width="100%" height="100%"
              class="small-img" />
            <div class="count">
              <span class="num">
                <count-up class="infor-card-count user-created-count" :id-name="`${activeType}${tabCode}TotalNum`"
                  :end-val="curStaticLocalData.totalNum || curStaticLocalData.totalCount" color="#0EFCFF" countSize="24"
                  :countWeight="countWeight">
                </count-up>
              </span>
            </div>
            <div class="active-static-tab-content-total-num-split-line"></div>
            <span class="active-static-tab-content-total-num-unit" v-if="tabCode == 'hwTab'">次</span>
            <span class="active-static-tab-content-total-num-unit" v-else-if="tabCode == 'studyTab'">个</span>
            <span class="active-static-tab-content-total-num-unit" v-else>数</span>
          </div>
        </div>
      </div>
      <ul class="active-static-tab-content-total-list">
        <li>
          <div class="active-static-tab-content-total-list-item-num">
            {{ curStaticLocalData.leftDataRate   }}
          </div>
          <div class="active-static-tab-content-total-list-item-title">
            {{ curStaticLocalData.leftDataText }}
          </div>
        </li>
        <li>
          <div class="active-static-tab-content-total-list-item-num">
            {{ curStaticLocalData.rightDataRate  }}
          </div>
          <div class="active-static-tab-content-total-list-item-title">
            {{ curStaticLocalData.rightDataText }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CountUp from "../../../components/countUp.vue";

export default {
  name: "active-content",
  data() {
    return {
      countWeight: 400,
      rankingLocalList: [],
      curStaticLocalData: {
        // id: '',
        // hwNum: 0,
        // hwCardNum: 0,
        // hwQuestionNum: 0,
        // hwSubmitRate: 0,
        hwCorrectRate: 0,
      }, //当前年级活跃下的统计数据
      subjectId: "",
      gradeId: "",
    };
  },
  components: {
    CountUp,
  },
  props: {
    activeType: String,
    tabCode: String,
    gradeList: Array,
    rankingList: Array,
    subjectList: Array,
  },
  watch: {
    rankingList: "initRankingList",
  },
  methods: {
    /**
     * 初始化 排行数据
     */
    initRankingList() {
      this.rankingLocalList = [];
      if (this.rankingList.length > 0) {
        for (let i = 0; i < this.rankingList.length; i++) {
          let newRankingObj = this.rankingList[i];
          if (this.activeType === "grade") {
            newRankingObj.id = this.rankingList[i].grade_id;
            newRankingObj.name = this.rankingList[i].grade_name;
            this.handleData(1, this.rankingList[i], newRankingObj);
          } else if (this.activeType === "evaluation") {
            if (this.rankingList[i].teaId == '') {
              continue;
            }
            newRankingObj.id = this.rankingList[i].teaId;
            newRankingObj.name = this.rankingList[i].teaName;
            this.handleData(1, this.rankingList[i], newRankingObj);
          } else if (this.activeType === "class") {
            newRankingObj.id = this.rankingList[i].class_id;
            newRankingObj.name = this.rankingList[i].class_name;
            this.handleData(1, this.rankingList[i], newRankingObj);
          } else if (this.activeType === "teacher") {
            newRankingObj.id =
              this.tabCode == "hwTab" ||
                this.tabCode == "studyTab" ||
                this.tabCode == "interTab"
                ? this.rankingList[i].tea_id
                : this.rankingList[i].user_id;
            newRankingObj.name =
              this.tabCode == "hwTab" ||
                this.tabCode == "studyTab" ||
                this.tabCode == "interTab"
                ? this.rankingList[i].tea_name
                : this.rankingList[i].user_name;
            this.handleData(1, this.rankingList[i], newRankingObj);
          }
          this.rankingLocalList.push(newRankingObj);
          this.curStaticLocalData = this.rankingLocalList[0];
        }
      } else {
        this.curStaticLocalData = {};
        this.handleData(-1, this.curStaticLocalData, this.curStaticLocalData);
      }
    },
    /**
     * 处理数据
     */
    handleData(type, item, newRankingObj) {
      if (this.tabCode == "hwTab") {
        newRankingObj.totalNum = item.hw_num;
        newRankingObj.leftDataRate =
          item.hwSubmitRate == undefined ? 0 + "%" : item.hwSubmitRate + "%";
        newRankingObj.leftDataText = "作业提交率";
        newRankingObj.rightDataRate =
          item.hwCorrectRate == undefined ? 0 + "%" : item.hwCorrectRate + "%";
        newRankingObj.rightDataText = "作业批改率";
      } else if (this.tabCode == "evaluation") {
        newRankingObj.totalNum = item.share_num;
        newRankingObj.leftDataRate = item.praiseNum?item.praiseNum + "次" :'0次';
        newRankingObj.leftDataText = "累计表扬";
        newRankingObj.rightDataRate =item.criticismNum? item.criticismNum + "次":'0次';
        newRankingObj.rightDataText = "累计改进";
      } else if (this.tabCode == "microTab") {
        newRankingObj.totalNum = item.share_num;
        newRankingObj.leftDataRate =
          item.read_rate == undefined
            ? 0 + "%"
            : this.$utils.toDecimal(item.read_rate * 100).toString() + "%";
        newRankingObj.leftDataText = "微课查看率";
        newRankingObj.rightDataRate =
          item.understand_rate == undefined
            ? 0 + "%"
            : this.$utils.toDecimal(item.understand_rate * 100).toString() +
            "%";
        newRankingObj.rightDataText = "微课看懂率";
      } else if (this.tabCode == "resTab") {
        newRankingObj.totalNum = item.res_num;
        newRankingObj.leftDataRate =
          item.read_rate == undefined
            ? 0 + "%"
            : this.$utils.toDecimal(item.read_rate * 100).toString() + "%";
        newRankingObj.leftDataText = "课件查看率";
        newRankingObj.rightDataRate =
          item.understand_rate == undefined
            ? 0 + "%"
            : this.$utils.toDecimal(item.understand_rate * 100).toString() +
            "%";
        newRankingObj.rightDataText = "课件看懂率";
      } else if (this.tabCode == "studyTab") {
        newRankingObj.totalNum = item.send_num;
        newRankingObj.leftDataRate =
          item.partake_num == undefined ? 0 : item.partake_num;
        newRankingObj.leftDataText = "学生参与数";
        newRankingObj.rightDataRate =
          item.partake_rate == undefined
            ? 0 + "%"
            : this.$utils.toDecimal(item.partake_rate * 100).toString() + "%";
        newRankingObj.rightDataText = "学生参与率";
      } else if (this.tabCode == "interTab") {
        newRankingObj.totalNum = item.stu_total_num + item.tea_total_num;
        newRankingObj.leftDataRate =
          item.stu_total_num == undefined ? 0 : item.stu_total_num;
        newRankingObj.leftDataText = "学生消息数";
        newRankingObj.rightDataRate =
          item.tea_total_num == undefined ? 0 : item.tea_total_num;
        newRankingObj.rightDataText = "教师消息数";
      }
    },
    /**
     *初始化时间年级班级学科等参数
     */
    initParams() {
      this.subjectId = "";
      this.gradeId = "";
      if (this.$refs.subjectSelectRef) {
        this.$refs.subjectSelectRef.clearSingleSelect();
      }
      if (this.$refs.gradeSelectRef) {
        this.$refs.gradeSelectRef.clearSingleSelect();
      }
      this.$emit("update-selected-data", this.subjectId, this.gradeId);
    },
    /**
     * 选中当前排行榜已选中项
     */
    changeSelectRank(index) {
      this.curStaticLocalData = this.rankingLocalList[index];
    },
    /**
     * 学科修改时通知父页面修改学科
     */
    changeSubject(id) {
      if (id == "0") {
        id = "";
      }
      this.$emit("update-selected-data", id, this.gradeId);
    },
    /**
     * 年级修改时通知父页面修改年级
     */
    changeGrade(id) {
      if (id == "0") {
        id = "";
      }
      this.$emit("update-selected-data", this.subjectId, id);
    },
  },
  mounted() { },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
@import "../../../style/layout";

.active-static-tab-content-ranking-split-line {
  background-image: url("../../../assets/images/databoard/active-icon.png");
}

.active-static-tab-content-ranking-item:nth-child(-n + 0) {
  .active-static-tab-content-ranking-item-num {
    color: #0efcff !important;
  }
}

.active-static-tab-content-total-list {
  display: flex;
  justify-content: center;
}
</style>

<style lang="scss">
.active-static-tab-content-total-sel-box {
  display: flex;

  .ivu-select {
    /*width: 93px !important;*/
    padding-right: 5px;
    text-align: center;
    color: #0efcff !important;
  }

  .ivu-select-selection {
    height: 26px !important;
    background: rgba(14, 252, 255, 0.05) !important;
    box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
    border-radius: 13px !important;
    border: unset !important;
  }

  .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
    color: #0efcff !important;
  }

  .ivu-select-arrow {
    color: #0efcff !important;
  }

  .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 26px !important;
    line-height: 26px !important;
  }

  .ivu-select-dropdown {
    max-height: 95px;
    background: rgba(10, 18, 39, 0.97);
    box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
    border-radius: 5px;
  }

  .ivu-select-item {
    color: #0efcff !important;
  }

  .ivu-select-item:hover {
    background: #0efcff !important;
    color: #0a1227 !important;
  }

  .ivu-select-item-focus {
    background: #0efcff !important;
    color: #0a1227 !important;
  }
}
</style>
